module.exports = {
  encode: require('./dist/plantuml-encoder').encode,
  decode: require('./dist/plantuml-decoder').decode
}
